import { useMemo } from 'react';
import { ImageSize, SectionContent, TextSize } from '../../models';
import { ImageContentDisplay } from '../images/ImageContentDisplay';
import { ContentHtml } from './ContentHtml';
import { LinkContentDisplay } from './LinkContentDisplay';

interface Props {
    before?: React.ReactNode;
    reverse?: boolean;
    content: SectionContent;
    textSize?: TextSize;
    imageSize?: ImageSize;
}

export const SectionContentDisplay = ({
    reverse,
    content,
    textSize,
    imageSize,
    before,
}: Props): React.ReactElement<any, any> | null => {
    const { colName, imageColClass, contentColClass, paddingFirstCol, paddingSecondCol } =
        useMemo(() => {
            const colName = reverse ? 'order-md-last' : '';
            const contentColClass = !content.image ? 12 : imageSize === 'sm' ? 9 : 6;
            const imageColClass = contentColClass === 6 ? 6 : 3;
            const paddingFirstCol = content.image
                ? reverse
                    ? 'pl-sm-0 pl-md-4'
                    : 'pr-sm-0 pr-md-4'
                : '';
            const paddingSecondCol = content.image
                ? reverse
                    ? 'pr-sm-0 pr-md-4'
                    : 'pl-sm-0 pl-md-4'
                : '';

            return {
                colName,
                imageColClass,
                contentColClass,
                paddingFirstCol,
                paddingSecondCol,
            };
        }, [content.image, reverse, imageSize]);

    const h2DisplayClass = textSize === 'md' ? 'display-6' : 'display-5';

    return (
        <div className="py-5 px-sm-5 px-4">
            {before}
            <div className="row">
                <div
                    className={`col-sm-12 col-md-${contentColClass} ${colName} ${paddingFirstCol}`}
                >
                    <div className="d-flex align-items-center h-100">
                        <div>
                            {content.header && (
                                <h2 className={`${h2DisplayClass} mb-4 content-header`}>
                                    {content.header}
                                </h2>
                            )}
                            {content.body && (
                                <ContentHtml
                                    source={content.body}
                                    className={textSize === 'md' ? '' : 'large'}
                                />
                            )}
                            {content.link && (
                                <div>
                                    <LinkContentDisplay link={content.link} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {content.image && (
                    <div className={`col-sm-12 col-md-${imageColClass} ${paddingSecondCol}`}>
                        <ImageContentDisplay image={content.image} />
                    </div>
                )}
            </div>
        </div>
    );
};
